import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import { WEMA } from "../moving_averages/WEMA";
import { WilderSmoothing } from "../moving_averages/WilderSmoothing";
import { MDM } from "./MinusDM";
import { PDM } from "./PlusDM";
import { TrueRange } from "./TrueRange";
export var ADXInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(ADXInput, _IndicatorInput);

  function ADXInput() {
    _classCallCheck(this, ADXInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(ADXInput).apply(this, arguments));
  }

  return ADXInput;
}(IndicatorInput);
export var ADXOutput =
/*#__PURE__*/
function (_IndicatorInput2) {
  _inherits(ADXOutput, _IndicatorInput2);

  function ADXOutput() {
    _classCallCheck(this, ADXOutput);

    return _possibleConstructorReturn(this, _getPrototypeOf(ADXOutput).apply(this, arguments));
  }

  return ADXOutput;
}(IndicatorInput);
export var ADX =
/*#__PURE__*/
function (_Indicator) {
  _inherits(ADX, _Indicator);

  function ADX(input) {
    var _this;

    _classCallCheck(this, ADX);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ADX).call(this, input));
    var lows = input.low;
    var highs = input.high;
    var closes = input.close;
    var period = input.period;
    var format = _this.format;
    var plusDM = new PDM({
      high: [],
      low: []
    });
    var minusDM = new MDM({
      high: [],
      low: []
    });
    var emaPDM = new WilderSmoothing({
      period: period,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var emaMDM = new WilderSmoothing({
      period: period,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var emaTR = new WilderSmoothing({
      period: period,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var emaDX = new WEMA({
      period: period,
      values: [],
      format: function format(v) {
        return v;
      }
    });
    var tr = new TrueRange({
      low: [],
      high: [],
      close: []
    });

    if (!(lows.length === highs.length && highs.length === closes.length)) {
      throw new Error("Inputs(low,high, close) not of equal size");
    }

    _this.result = [];
    ADXOutput;
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var tick, index, lastATR, lastAPDM, lastAMDM, lastPDI, lastMDI, lastDX, smoothedDX, calcTr, calcPDM, calcMDM, _lastATR, _lastAPDM, _lastAMDM, diDiff, diSum;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              tick = _context.sent;
              index = 0;
              lastATR = 0;
              lastAPDM = 0;
              lastAMDM = 0;

            case 7:
              if (!true) {
                _context.next = 25;
                break;
              }

              calcTr = tr.nextValue(tick);
              calcPDM = plusDM.nextValue(tick);
              calcMDM = minusDM.nextValue(tick);

              if (!(calcTr === undefined)) {
                _context.next = 16;
                break;
              }

              _context.next = 14;
              return;

            case 14:
              tick = _context.sent;
              return _context.abrupt("continue", 7);

            case 16:
              _lastATR = emaTR.nextValue(calcTr);
              _lastAPDM = emaPDM.nextValue(calcPDM);
              _lastAMDM = emaMDM.nextValue(calcMDM);

              if (_lastATR !== undefined && _lastAPDM !== undefined && _lastAMDM !== undefined) {
                lastPDI = _lastAPDM * 100 / _lastATR;
                lastMDI = _lastAMDM * 100 / _lastATR;
                diDiff = Math.abs(lastPDI - lastMDI);
                diSum = lastPDI + lastMDI;
                lastDX = diDiff / diSum * 100;
                smoothedDX = emaDX.nextValue(lastDX); // console.log(tick.high.toFixed(2), tick.low.toFixed(2), tick.close.toFixed(2) , calcTr.toFixed(2), calcPDM.toFixed(2), calcMDM.toFixed(2), lastATR.toFixed(2), lastAPDM.toFixed(2), lastAMDM.toFixed(2), lastPDI.toFixed(2), lastMDI.toFixed(2), diDiff.toFixed(2), diSum.toFixed(2), lastDX.toFixed(2));
              }

              _context.next = 22;
              return {
                adx: smoothedDX,
                pdi: lastPDI,
                mdi: lastMDI
              };

            case 22:
              tick = _context.sent;
              _context.next = 7;
              break;

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    lows.forEach(function (tick, index) {
      var result = _this.generator.next({
        high: highs[index],
        low: lows[index],
        close: closes[index]
      });

      if (result.value !== undefined && result.value.adx !== undefined) {
        _this.result.push({
          adx: format(result.value.adx),
          pdi: format(result.value.pdi),
          mdi: format(result.value.mdi)
        });
      }
    });
    return _this;
  }

  _createClass(ADX, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price).value;

      if (result !== undefined && result.adx !== undefined) {
        return {
          adx: this.format(result.adx),
          pdi: this.format(result.pdi),
          mdi: this.format(result.mdi)
        };
      }
    }
  }]);

  return ADX;
}(Indicator);
ADX.calculate = adx;
export function adx(input) {
  Indicator.reverseInputs(input);
  var result = new ADX(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}